import { BitSet } from './bitset';
function* bitmaskGenerator() {
    let n = 1;
    while (true) {
        const mask = new BitSet(n);
        mask.set(n - 1);
        ++n;
        yield mask;
    }
}
export class Component {
    constructor() {
        // tslint:disable-next-line: variable-name
        this.__component = true;
    }
    static get bitmask() {
        if (this._bitmask == null) {
            this._bitmask = this._bitmaskGenerator.next().value;
        }
        return this._bitmask;
    }
}
Component._bitmaskGenerator = bitmaskGenerator();
